import type React from 'react'

type Props = {
  className?: string
  size?: number
}

const IconArrowLeft: React.FC<Props> = ({ className, size = 20 }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.625 2.982c-.234-.21-.586-.21-.797 0-.234.235-.234.586 0 .797l2.25 2.227-2.226 2.25a.513.513 0 0 0 0 .773c.21.235.562.235.796 0l2.625-2.625a.565.565 0 0 0 .165-.398.49.49 0 0 0-.188-.375L5.625 2.982ZM6 .006c-3.328 0-6 2.695-6 6 0 3.328 2.672 6 6 6 3.305 0 6-2.672 6-6 0-3.305-2.695-6-6-6ZM6 10.88a4.871 4.871 0 0 1-4.875-4.875C1.125 3.334 3.305 1.13 6 1.13c2.672 0 4.875 2.203 4.875 4.875C10.875 8.7 8.672 10.88 6 10.88Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconArrowLeft
